import { format, parse } from "date-fns";

/**
 * Combines a date string (MM/dd/yyyy) and time string (HH:mm) into a formatted datetime string
 * @param date - Date string in format "MM/dd/yyyy" (e.g., "12/29/2025")
 * @param time - Time string in format "HH:mm" (e.g., "14:00")
 * @returns Formatted datetime string in format "yyyy-MM-dd HH:mm:ss.SSS" (e.g., "2025-12-29 14:00:00.000")
 */
export const formatDateTimeForAPI = (date: string, time: string): string => {
  const parsedDate = parse(date, "MM/dd/yyyy", new Date());
  const [hours, minutes] = time.split(":").map(Number);
  const combinedDateTime = new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate(),
    hours,
    minutes,
  );

  return format(combinedDateTime, "yyyy-MM-dd HH:mm:ss.SSS");
};
